import i18n from '../../../../../../utils/i18n';

export const servicesTags = [
	{
		label: i18n.t('companyforms.singleprimarysimple'),
		selected: false,
		group: i18n.t('provider.highlighted'),
		id: 'singleprimary',
	},
	{
		label: i18n.t('companyforms.singlesecondarysimple'),
		selected: false,
		group: i18n.t('provider.highlighted'),
		id: 'singlesecondary',
	},
	{
		label: i18n.t('companyforms.kivasimple'),
		selected: false,
		group: i18n.t('provider.highlighted'),
		id: 'kiva',
	},
	{
		label: i18n.t('companyforms.vszjasimple'),
		selected: false,
		group: i18n.t('provider.highlighted'),
		id: 'vszja',
	},
	// {
	// 	label: i18n.t('companyforms.entrepreneur'),
	// 	selected: false,
	// 	group: i18n.t('provider.highlighted'),
	// 	id: 'entrepreneur',
	// },

	{
		label: i18n.t('companyforms.btsimple'),
		selected: false,
		group: i18n.t('provider.highlighted'),
		id: 'bt',
	},
	{
		label: i18n.t('companyforms.kftsimple'),
		selected: false,
		group: i18n.t('provider.highlighted'),
		id: 'kft',
	},
	{
		label: i18n.t('companyforms.kktsimple'),
		selected: false,
		group: i18n.t('provider.furtheroptions'),
		id: 'kkt',
	},
	{
		label: i18n.t('companyforms.zrtsimple'),
		selected: false,
		group: i18n.t('provider.furtheroptions'),
		id: 'zrt',
	},
	{
		label: i18n.t('companyforms.nyrtsimple'),
		selected: false,
		group: i18n.t('provider.furtheroptions'),
		id: 'nyrt',
	},
	{
		label: i18n.t('companyforms.condosimple'),
		selected: false,
		group: i18n.t('provider.furtheroptions'),
		id: 'condo',
	},
	{
		label: i18n.t('companyforms.civilsimple'),
		selected: false,
		group: i18n.t('provider.furtheroptions'),
		id: 'civil',
	},
	{
		label: i18n.t('companyforms.citycouncil'),
		selected: false,
		group: i18n.t('provider.furtheroptions'),
		id: 'citycouncil',
	},
];

export const taxTags = [
	// {
	// 	label: i18n.t('companyforms.singleprimarysimple'),
	// 	selected: false,
	// 	group: i18n.t('provider.taxation'),
	// 	id: 'singleprimary',
	// },
	// {
	// 	label: i18n.t('companyforms.flattax'),
	// 	selected: false,
	// 	group: i18n.t('provider.taxation'),
	// 	id: 'flattax',
	// },
	// {
	// 	label: i18n.t('companyforms.vszjasimple'),
	// 	selected: false,
	// 	group: i18n.t('provider.taxation'),
	// 	id: 'vszja',
	// },
	{
		label: i18n.t('general.taxkiva'),
		selected: false,
		group: i18n.t('provider.taxation'),
		id: 'kiva',
	},
	{
		label: i18n.t('general.taxtao'),
		selected: false,
		group: i18n.t('provider.taxation'),
		id: 'tao',
	},
];

export const industryTags = [
	{
		label: i18n.t('industrylabels.construction'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'construction',
	},
	{
		label: i18n.t('industrylabels.engineer'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'engineer',
	},
	{
		label: i18n.t('industrylabels.vehicle'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'vehicle',
	},
	{
		label: i18n.t('industrylabels.manufacturing'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'manufacturing',
	},
	{
		label: i18n.t('industrylabels.IT'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'IT',
	},
	{
		label: i18n.t('industrylabels.realestate'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'realestate',
	},
	{
		label: i18n.t('industrylabels.retail'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'retail',
	},
	{
		label: i18n.t('industrylabels.wholesale'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'wholesale',
	},
	{
		label: i18n.t('industrylabels.agriculture'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'agriculture',
	},
	{
		label: i18n.t('industrylabels.education'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'education',
	},
	{
		label: i18n.t('industrylabels.art'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'art',
	},
	{
		label: i18n.t('industrylabels.medicine'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'medicine',
	},
	{
		label: i18n.t('industrylabels.beauty'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'beauty',
	},
	{
		label: i18n.t('industrylabels.finance'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'finance',
	},
	{
		label: i18n.t('industrylabels.travel'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'travel',
	},
	{
		label: i18n.t('industrylabels.logistics'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'logistics',
	},
	{
		label: i18n.t('industrylabels.etrade'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'etrade',
	},
	{
		label: i18n.t('industrylabels.startup'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'startup',
	},
	{
		label: i18n.t('industrylabels.lawyer'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'lawyer',
	},
	{
		label: i18n.t('industrylabels.courier'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'courier',
	},
	{
		label: i18n.t('industrylabels.sport'),
		selected: false,
		group: i18n.t('provider.industries'),
		id: 'sport',
	},
];

export const industryExperienceTags = [
	{
		label: i18n.t('industrylabels.construction'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'construction',
	},
	{
		label: i18n.t('industrylabels.engineer'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'engineer',
	},
	{
		label: i18n.t('industrylabels.vehicle'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'vehicle',
	},
	{
		label: i18n.t('industrylabels.manufacturing'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'manufacturing',
	},
	{
		label: i18n.t('industrylabels.IT'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'IT',
	},
	{
		label: i18n.t('industrylabels.realestate'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'realestate',
	},
	{
		label: i18n.t('industrylabels.retail'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'retail',
	},
	{
		label: i18n.t('industrylabels.wholesale'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'wholesale',
	},
	{
		label: i18n.t('industrylabels.agriculture'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'agriculture',
	},
	{
		label: i18n.t('industrylabels.education'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'education',
	},
	{
		label: i18n.t('industrylabels.art'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'art',
	},
	{
		label: i18n.t('industrylabels.medicine'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'medicine',
	},
	{
		label: i18n.t('industrylabels.beauty'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'beauty',
	},
	{
		label: i18n.t('industrylabels.finance'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'finance',
	},
	{
		label: i18n.t('industrylabels.travel'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'travel',
	},
	{
		label: i18n.t('industrylabels.logistics'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'logistics',
	},
	{
		label: i18n.t('industrylabels.etrade'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'etrade',
	},
	{
		label: i18n.t('industrylabels.startup'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'startup',
	},
	{
		label: i18n.t('industrylabels.lawyer'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'lawyer',
	},
	{
		label: i18n.t('industrylabels.courier'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'courier',
	},
	{
		label: i18n.t('industrylabels.sport'),
		selected: false,
		group: i18n.t('provider.expertinindustries'),
		id: 'sport',
	},
];

export const specialTags = [
	{
		label: i18n.t('provider.newlyfoundedcompanies'),
		selected: false,
		group: i18n.t('provider.special'),
		id: 'newlyfounded',
	},
	// {
	// 	label: i18n.t('provider.companiesengagedinforeigntrade'),
	// 	selected: false,
	// 	group: i18n.t('provider.special'),
	// 	id: 'foreigntradefilter',
	// },
	{
		label: i18n.t('provider.insideeu'),
		selected: false,
		group: i18n.t('provider.special'),
		id: 'insideEU',
	},
	{
		label: i18n.t('provider.outsideeu'),
		selected: false,
		group: i18n.t('provider.special'),
		id: 'outsideEU',
	},
];

export const bankTags = [
	{
		label: i18n.t('banks.bankingoption1'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt1',
	},
	{
		label: i18n.t('banks.bankingoption2'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt2',
	},
	{
		label: i18n.t('banks.bankingoption3'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt3',
	},
	{
		label: i18n.t('banks.bankingoption4'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt4',
	},
	{
		label: i18n.t('banks.bankingoption5'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt5',
	},
	{
		label: i18n.t('banks.bankingoption6'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt6',
	},
	{
		label: i18n.t('banks.bankingoption7'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt7',
	},
	{
		label: i18n.t('banks.bankingoption8'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt8',
	},
	{
		label: i18n.t('banks.bankingoption9'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'opt9',
	},
	{
		label: i18n.t('general.other'),
		selected: false,
		group: i18n.t('provider.companysmainbank'),
		id: 'other',
	},
];

export const invoiceTags = [
	{
		label: i18n.t('invoicings.invoicingoption1'),
		selected: false,
		group: i18n.t('provider.companysinvoicing'),
		id: 'opt1',
	},
	{
		label: i18n.t('invoicings.invoicingoption2'),
		selected: false,
		group: i18n.t('provider.companysinvoicing'),
		id: 'opt2',
	},
	{
		label: i18n.t('invoicings.invoicingoption3'),
		selected: false,
		group: i18n.t('provider.companysinvoicing'),
		id: 'opt3',
	},
	{
		label: i18n.t('invoicings.invoicingoption4'),
		selected: false,
		group: i18n.t('provider.companysinvoicing'),
		id: 'opt4',
	},
	{
		label: i18n.t('invoicings.invoicingoption5'),
		selected: false,
		group: i18n.t('provider.companysinvoicing'),
		id: 'opt5',
	},
	{
		label: i18n.t('invoicings.invoicingoption6'),
		selected: false,
		group: i18n.t('provider.companysinvoicing'),
		id: 'opt6',
	},
	{
		label: i18n.t('invoicings.invoicingoption7'),
		selected: false,
		group: i18n.t('provider.companysinvoicing'),
		id: 'opt7',
	},
	{
		label: i18n.t('general.other'),
		selected: false,
		group: i18n.t('provider.companysinvoicing'),
		id: 'other',
	},
];

export const softwareTags = [
	{
		label: i18n.t('softwares.softwareoption1'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt1',
	},
	{
		label: i18n.t('softwares.softwareoption2'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt2',
	},
	{
		label: i18n.t('softwares.softwareoption3'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt3',
	},
	{
		label: i18n.t('softwares.softwareoption4'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt4',
	},
	{
		label: i18n.t('softwares.softwareoption5'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt5',
	},
	{
		label: i18n.t('softwares.softwareoption6'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt6',
	},
	{
		label: i18n.t('softwares.softwareoption7'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt7',
	},
	{
		label: i18n.t('softwares.softwareoption8'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt8',
	},
	{
		label: i18n.t('softwares.softwareoption9'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt9',
	},
	{
		label: i18n.t('softwares.softwareoption10'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt10',
	},
	{
		label: i18n.t('softwares.softwareoption11'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt11',
	},
	{
		label: i18n.t('softwares.softwareoption12'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt12',
	},
	{
		label: i18n.t('softwares.softwareoption13'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt13',
	},
	{
		label: i18n.t('softwares.softwareoption14'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt14',
	},
	{
		label: i18n.t('softwares.softwareoption15'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt15',
	},
	{
		label: i18n.t('softwares.softwareoption16'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt16',
	},
	{
		label: i18n.t('softwares.softwareoption17'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt17',
	},
	{
		label: i18n.t('softwares.softwareoption18'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt18',
	},
	{
		label: i18n.t('softwares.softwareoption19'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt19',
	},
	{
		label: i18n.t('softwares.softwareoption20'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'opt20',
	},
	{
		label: i18n.t('general.other'),
		selected: false,
		group: i18n.t('provider.companyssoftware'),
		id: 'other',
	},
];

export const specialIndustryTags = [
	{
		label: i18n.t('provider.specialpreftextN1'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'registersimplifiedpayroll',
	},
	{
		label: i18n.t('provider.specialpreftextN2'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'companycar',
	},
	{
		label: i18n.t('provider.specialpreftextN3'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'cashregister',
	},
	{
		label: i18n.t('provider.specialpreftextN4'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'multipleaccounts',
	},
	{
		label: i18n.t('provider.specialpreftextN5'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'cashflowvat',
	},
	{
		label: i18n.t('provider.specialpreftextN6'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'loanreview',
	},
	{
		label: i18n.t('provider.specialpreftextN7'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'earlyclosure',
	},
	{
		label: i18n.t('provider.specialpreftextN8'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'preparingstatements',
	},
	{
		label: i18n.t('provider.specialpreftextN9'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'invoicing',
	},
	{
		label: i18n.t('provider.specialpreftextN10'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'transfering',
	},
	{
		label: i18n.t('provider.specialpreftextN11'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'auditcooperation',
	},
	{
		label: i18n.t('provider.specialpreftextN12'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'vatadjusting',
	},
	{
		label: i18n.t('provider.specialpreftextN13'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'projectsupport',
	},
	{
		label: i18n.t('provider.specialpreftextN14'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'environmentalfees',
	},
	{
		label: i18n.t('provider.specialpreftextN15'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'matchinginvoices',
	},
	{
		label: i18n.t('provider.specialpreftextN16'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'actualstore',
	},
	{
		label: i18n.t('provider.specialpreftextN17'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'stockhandling',
	},
	{
		label: i18n.t('provider.specialpreftextN18'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'differentialvat',
	},
	{
		label: i18n.t('provider.specialpreftextN19'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'matchinginvoicestravel',
	},
	{
		label: i18n.t('provider.specialpreftextN20'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'matchinginvoicesretail',
	},
	{
		label: i18n.t('provider.specialpreftextN21'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'matchinginvoiceswholesale',
	},
	{
		label: i18n.t('provider.specialpreftextN22'),
		selected: false,
		group: i18n.t('provider.specialindustryfilters'),
		id: 'matchinginvoicestravel',
	},
];
